/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { NotificationDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get Inbox
 */
export const getNotification = (signal?: AbortSignal) => {
  return customInstance<NotificationDto[]>({
    url: `/notification`,
    method: "GET",
    signal,
  });
};

export const getGetNotificationInfiniteQueryKey = () => {
  return ["infinite", `/notification`] as const;
};

export const getGetNotificationQueryKey = () => {
  return [`/notification`] as const;
};

export const getGetNotificationInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getNotification>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getNotification>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotification>>> = ({
    signal,
  }) => getNotification(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getNotification>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotification>>
>;
export type GetNotificationInfiniteQueryError = void;

export function useGetNotificationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getNotification>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getNotification>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotification>>,
          TError,
          Awaited<ReturnType<typeof getNotification>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getNotification>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getNotification>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotification>>,
          TError,
          Awaited<ReturnType<typeof getNotification>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getNotification>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getNotification>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Inbox
 */

export function useGetNotificationInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getNotification>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getNotification>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNotificationInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetNotificationQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotification>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotification>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotification>>> = ({
    signal,
  }) => getNotification(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotification>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotification>>
>;
export type GetNotificationQueryError = void;

export function useGetNotification<
  TData = Awaited<ReturnType<typeof getNotification>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotification>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotification>>,
          TError,
          Awaited<ReturnType<typeof getNotification>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotification<
  TData = Awaited<ReturnType<typeof getNotification>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotification>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotification>>,
          TError,
          Awaited<ReturnType<typeof getNotification>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotification<
  TData = Awaited<ReturnType<typeof getNotification>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotification>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Inbox
 */

export function useGetNotification<
  TData = Awaited<ReturnType<typeof getNotification>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotification>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNotificationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Mark All Read
 */
export const putNotificationReadAll = () => {
  return customInstance<number>({
    url: `/notification/read-all`,
    method: "PUT",
  });
};

export const getPutNotificationReadAllMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putNotificationReadAll>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putNotificationReadAll>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["putNotificationReadAll"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putNotificationReadAll>>,
    void
  > = () => {
    return putNotificationReadAll();
  };

  return { mutationFn, ...mutationOptions };
};

export type PutNotificationReadAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof putNotificationReadAll>>
>;

export type PutNotificationReadAllMutationError = void;

/**
 * @summary Mark All Read
 */
export const usePutNotificationReadAll = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putNotificationReadAll>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putNotificationReadAll>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPutNotificationReadAllMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Unread Count
 */
export const getNotificationUnreadCount = (signal?: AbortSignal) => {
  return customInstance<number>({
    url: `/notification/unread-count`,
    method: "GET",
    signal,
  });
};

export const getGetNotificationUnreadCountInfiniteQueryKey = () => {
  return ["infinite", `/notification/unread-count`] as const;
};

export const getGetNotificationUnreadCountQueryKey = () => {
  return [`/notification/unread-count`] as const;
};

export const getGetNotificationUnreadCountInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getNotificationUnreadCount>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getNotificationUnreadCount>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationUnreadCountInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>
  > = ({ signal }) => getNotificationUnreadCount(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationUnreadCountInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationUnreadCount>>
>;
export type GetNotificationUnreadCountInfiniteQueryError = void;

export function useGetNotificationUnreadCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getNotificationUnreadCount>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getNotificationUnreadCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getNotificationUnreadCount>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationUnreadCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getNotificationUnreadCount>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getNotificationUnreadCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getNotificationUnreadCount>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationUnreadCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getNotificationUnreadCount>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getNotificationUnreadCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Unread Count
 */

export function useGetNotificationUnreadCountInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getNotificationUnreadCount>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getNotificationUnreadCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetNotificationUnreadCountInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetNotificationUnreadCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationUnreadCount>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getNotificationUnreadCount>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationUnreadCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>
  > = ({ signal }) => getNotificationUnreadCount(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationUnreadCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationUnreadCount>>
>;
export type GetNotificationUnreadCountQueryError = void;

export function useGetNotificationUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationUnreadCount>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotificationUnreadCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getNotificationUnreadCount>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationUnreadCount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotificationUnreadCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getNotificationUnreadCount>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetNotificationUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationUnreadCount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotificationUnreadCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Unread Count
 */

export function useGetNotificationUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationUnreadCount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNotificationUnreadCount>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetNotificationUnreadCountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Mark Read
 */
export const putNotificationIdRead = (id: number) => {
  return customInstance<boolean>({
    url: `/notification/${id}/read`,
    method: "PUT",
  });
};

export const getPutNotificationIdReadMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putNotificationIdRead>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putNotificationIdRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["putNotificationIdRead"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putNotificationIdRead>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return putNotificationIdRead(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutNotificationIdReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof putNotificationIdRead>>
>;

export type PutNotificationIdReadMutationError = void;

/**
 * @summary Mark Read
 */
export const usePutNotificationIdRead = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putNotificationIdRead>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putNotificationIdRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getPutNotificationIdReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
